export default "__VITE_ASSET__BX494En___"